import { useEffect, useRef, useState } from "react";
import { HaberForm, PageTitleComp, RightLayoutContainer } from "../../styledElements";
import { Button, PageHeader, Radio, Select } from "antd";
import { RadioButtonStyle } from "../../pageStyled";
import CSVJobCardViewer from "../../JobCardCSV/CSVJobCardViewer";
import { useLocation, useNavigate } from "react-router";
import PrintMultiStageJobCardDetails from "../../Print/printMultiStageJobCardDetails";
import PrintJobCardDetails from "../../Print/printJobCardDetails";
import PrintSheetJobCardDetails from "../../Print/printSheetJobCardDetails";
import PrintDuplexJobCardDetails from "../../Print/printDuplexJobCardDetails";
import Iconmoon from "../../../Components/IconsFiles/icon";

const JobCardDetailsViewer = () => {
    const [viewerType,setViewerType] = useState("pdf");
    const [print,setPrint] = useState(false);
    const [loading,setLoading] = useState(true);
    const [selectedSheet,setSelectedSheet] = useState("sheet_1");
    const location = useLocation();
    const navigate = useNavigate();
    const {jobId="",jobcardCode="",solution={},orderDetailsList=[],type="",machineType ="",cutter_type = "",jobCard={},acceptedSolution={}} = location.state||{};
    console.log(location.state);
    
    useEffect(()=>{
        if(!location?.state)
            navigate("../job-cards");
    },[])

    return (
        <RightLayoutContainer>
            <PageTitleComp>
                <PageHeader
                    ghost={false}
                    title={"JobCard Preview"}
                    onBack={()=>window.history.back()}
                    extra={[
                        viewerType == "csv" ?<Select 
                            options={[
                                {
                                    label: "Deckle Plan",
                                    value: "sheet_1",
                                },
                                {
                                    label: "Order Summary",
                                    value: "sheet_2",
                                }
                            ]}
                            value={selectedSheet}
                            onChange={(e)=>setSelectedSheet(e)}
                            className="styledSelect"
                        >
                        </Select>:<></>,
                        <HaberForm>
                            <RadioButtonStyle>
                                <div className="switchRadio setHeightPadding"
                                    style={{display:"flex",
                                        justifyContent:"center",
                                    }}
                                >
                                    <Radio.Group
                                        options={[
                                            {
                                                label:"PDF",
                                                value:"pdf"
                                            },
                                            {
                                                label:"CSV",
                                                value:"csv"
                                            }
                                        ]}
                                        value={viewerType}
                                        onChange={(e)=>{
                                            setViewerType(e.target.value)
                                            if(e.target.value == "csv"){
                                                setLoading(true);
                                                setSelectedSheet("sheet_1")
                                            }
                                        }}
                                        optionType="button"
                                        buttonStyle="solid"
                                    />
                                </div>
                            </RadioButtonStyle>
                        </HaberForm>,
                        <>
                            {viewerType == "pdf"
                                ?<Button className="themeBtn" onClick={()=>setPrint(true)}>
                                    <Iconmoon icon="printer" size={16} color="#FFFFFF" />
                                    Print Job Card
                                </Button>
                                :<Button className="themeBtn" disabled={loading} onClick={()=>setPrint(true)}>
                                    <Iconmoon icon="download" size={16} color="#FFFFFF" />
                                    Download CSV
                                </Button>
                            }
                        </>
                    ]}
                />
            </PageTitleComp>
            
            {viewerType == "csv" 
                ? <CSVJobCardViewer type={type} machineType={machineType} jobId={jobId} jobcardCode={jobcardCode} solution={solution} orderDetails={orderDetailsList} print={print} setPrint={setPrint} loading={loading} setLoading={setLoading} selectedSheet={selectedSheet}/> 
                : (type == "multiStage") ? <PrintMultiStageJobCardDetails jobId={jobId} jobcardCode={jobcardCode} solution={solution} orderDetailsList={orderDetailsList} print={print} setPrint={setPrint} module={"deckle"}/> 
                : (machineType == "rewinder") ? <PrintJobCardDetails jobId={jobId} jobcardCode={jobcardCode} solution={solution} orderDetailsList={orderDetailsList} print={print} setPrint={setPrint} module={"deckle"}/>
                : (cutter_type == "simplex")? <PrintSheetJobCardDetails jobId={jobId} jobcardCode={jobcardCode} solution={solution} orderDetailsList={orderDetailsList} cutter_type={cutter_type} jobCard={jobCard} acceptedSolution={acceptedSolution} print={print} setPrint={setPrint} module={"deckle"}/>
                : <PrintDuplexJobCardDetails jobId={jobId} jobcardCode={jobcardCode} solution={solution} orderDetailsList={orderDetailsList} cutter_type={cutter_type} jobCard={jobCard} acceptedSolution={acceptedSolution} print={print} setPrint={setPrint} module={"deckle"}/>
            }
        
        </RightLayoutContainer>
    )
}

export default JobCardDetailsViewer;